import React, { useState, useEffect } from "react";
import Logo from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { useCookies } from 'react-cookie';
import { useMediaQuery } from "@mui/material";
import { IoMdMenu } from "react-icons/io";
import { IoClose } from "react-icons/io5"; // Close icon for mobile menu
import SheetBar from "./sheetBar";
const getInitials = (firstName, lastName) => {
    return (firstName[0] + lastName[0]).toUpperCase();
};

const Navbar = ({ userDetails }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [, , removeCookie] = useCookies(['jwtToken']);
    const isDesktop = useMediaQuery("(min-width: 720px)");

    const logout = async () => {
        toggleDropdown(); // Close the dropdown
        removeCookie('jwtToken');
        toast.success("Logout successful");
        window.location.reload();
    };

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        // Close dropdown when clicking outside
        const closeDropdownOnClickOutside = (e) => {
            if (isDropdownOpen && !e.target.closest(".navbar-dropdown")) {
                toggleDropdown();
            }
        };

        document.addEventListener("mousedown", closeDropdownOnClickOutside);
        return () => {
            document.removeEventListener("mousedown", closeDropdownOnClickOutside);
        };
    }, [isDropdownOpen]);
    if (isDesktop) {
    return (
        <div className={"w-full bg-white z-40 drop-shadow-xl"}>
            <nav className={"px-[30px] py-4"}>
                <div className="flex flex-row justify-between content-center items-center">
                    <Link to="/">
                        <img
                            src={Logo}
                            alt="Logo of krtrimaIQ Cognitive Solutions"
                            width={250}
                            className="cursor-pointer"
                        />
                    </Link>
                    <div className="flex items-center mx-auto justify-center">
                        <div className="whitespace-nowrap text-gray-600 text-4xl font-medium">
                            Generative AI Demo Hub
</div>                        </div>
                        {userDetails ? (
                            <div className="relative">
                                <div className="flex items-center cursor-pointer" onClick={toggleDropdown}>
                                    <div className="w-12 h-12 rounded-full bg-[#23479F] text-white text-xl flex items-center justify-center">
                                        {getInitials(userDetails.first_name, userDetails.last_name)}
                                    </div>
                                    <div className="ml-3">
                                        <div className="font-bold">
                                            {userDetails.first_name} {userDetails.last_name}
                                        </div>
                                        <div>{userDetails.organization}</div>
                                    </div>
                                </div>
                                {isDropdownOpen && (
                                    <div className="navbar-dropdown absolute top-full mt-2 right-0 w-40 bg-white border border-gray-300 shadow-lg rounded-lg">
                                        <button
                                            onClick={logout}
                                            className="block w-full text-left px-4 py-2 hover:bg-light-blue focus:outline-none rounded-t cursor-pointer"
                                        >
                                            Log Out
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : null}
                    </div>
                </nav>
                <Toaster position="top-center" reverseOrder={false} />
            </div>
        );
    }

    return (
        <div className="w-full bg-white z-999 drop-shadow-xl">
        <nav className="px-5 py-4 flex justify-between items-center">
            <Link to="/">
                <img src={Logo} alt="Logo" width={200} className="cursor-pointer" />
            </Link>
            <button onClick={() => setIsMobileMenuOpen(true)}>
                <IoMdMenu size={30} />
            </button>
        </nav>

        {isMobileMenuOpen && <SheetBar userDetails={userDetails} logout={logout} closeSheet={() => setIsMobileMenuOpen(false)} />}
    </div>
    );
};

export default Navbar;
